import { Controller } from "@hotwired/stimulus"

// Single-item AJAX autocomplete. Pair a visible search input with a hidden ID field.
// Usage:
//   data-controller="ajax-autocomplete"
//   data-ajax-autocomplete-url-value="/path/to/search"
//   data-ajax-autocomplete-target="search"  (text input)
//   data-ajax-autocomplete-target="id"      (hidden input)
export default class extends Controller {
  static targets = ["search", "id"]
  static values  = { url: String }

  connect() {
    $(this.searchTarget).autocomplete({
      source: (request, response) => {
        $.getJSON(this.urlValue, { term: request.term }, response)
      },
      minLength: 2,
      select: (event, ui) => {
        this.idTarget.value   = ui.item.id
        this.searchTarget.value = ui.item.label
        return false
      },
      change: (_event, ui) => {
        if (!ui.item) this.idTarget.value = ""
      }
    })
  }

  disconnect() {
    if ($(this.searchTarget).data("ui-autocomplete")) {
      $(this.searchTarget).autocomplete("destroy")
    }
  }
}
